import { createContext, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const AppContext = createContext();
export const AppConsumer = AppContext.Consumer;

export function AppProvider(props) {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({
        "amount": "10",
        "category": 0,
        "difficulty": "any"
    });
    const [questions, setQuestions] = useState(null);
    const [quizStats, setQuizStats] = useState([]);
    const [categoryLookup, setCategoryLookup] = useState([]);

    const updateSettings = (s) => {
        setSettings(s);
    }

    const updateQuizStats = (s) => {
        setQuizStats(s);
    }

    const hasQuestions = useCallback(()=> questions !== null, [questions]);

    const getQuestions = (text) => {
        const questionNumber = settings.amount;
        const questionCategory = settings.category !== 0 ? "&category=" + settings.category : "";
        const questionDifficulty = settings.difficulty !== "any" ? "&difficulty=" + settings.difficulty : "";

        const apiURL = "https://opentdb.com/api.php?amount=" + questionNumber + questionCategory + questionDifficulty + "&type=multiple";

        fetch(apiURL)
            .then((response) => response.json())
            .then((data) => {
                //console.log(data);
                if (data.response_code === 0) {
                    setQuestions(data);
                    navigate("/quiz");
                } else if (data.response_code === 1) {
                    alert("Oh no! There is no question set with given parameters. Please try something else.");
                }
            })
            .catch((err) => {
                console.log(err.message);
            });
        
            console.log(text);
    };

    const clearQuestions = () => {
        setQuestions(null);
    };

    const getCategoryLookup = () => {
        fetch("https://opentdb.com/api_category.php")
            .then((response) => response.json())
            .then((data) => {
                setCategoryLookup(data.trivia_categories);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };

    // useEffect(()=>{
    //     getQuestions("settings update");
    // }, [settings]);

    const value = {
        settings,
        updateSettings,
        questions,
        hasQuestions,
        quizStats,
        updateQuizStats,
        getQuestions,
        getCategoryLookup,
        categoryLookup,
        clearQuestions
    };

    return (
        <AppContext.Provider value={value}>
          {props.children}
        </AppContext.Provider>
    );
}